import type {StoreApi} from 'zustand/vanilla';

import type {Nullish} from 'shared/web';

import type {EagGridState, EagGridStore} from '../createEagGridStore';

type DragActions = Pick<EagGridStore, 'setActiveDragId' | 'clearDragState' | 'setDragOver'>;

/** Column drag-and-drop actions. Bodies moved verbatim from createUiActions. */
export function createDragActions(store: StoreApi<EagGridState>): DragActions {
  return {
    setActiveDragId: (activeDragId: string | Nullish) => {
      if (store.getState().activeDragId === activeDragId) {
        return;
      }
      store.setState({activeDragId});
    },

    clearDragState: () => {
      const state = store.getState();
      if (state.activeDragId === null && state.overColumnId === null && state.dropSide === null) {
        return;
      }
      store.setState({activeDragId: null, overColumnId: null, dropSide: null});
    },

    setDragOver: (overColumnId: string | Nullish, dropSide: 'left' | 'right' | Nullish) => {
      const state = store.getState();
      if (state.overColumnId === overColumnId && state.dropSide === dropSide) {
        return;
      }
      store.setState({overColumnId, dropSide});
    },
  };
}
